export { default } from "./HomeCaption";
